import { CollectionAudience } from '@amzn/awscat-pattern-library-service-model';

import CreateCollection from './CreateCollection';
import EditCollection from './EditCollection';
import MyCollection from './MyCollection';
import CollectionViewer from './CollectionViewer';
import HeaderCollectionDropdown from './CollectionDropdown';
import constants from '../../common/constants';
import CollectionOwners from './CollectionOwners';
import EditCollectionOwners from './EditCollectionOwners';

const collectionAudienceLabelMap = new Map([
  [CollectionAudience.PRIVATE, constants.MY_COLLECTION_AUDIENCE_LABEL_ONLY_OWNER],
  [CollectionAudience.INTERNAL, constants.MY_COLLECTION_AUDIENCE_LABEL_INTERNAL],
]);

export {
  CreateCollection,
  EditCollection,
  MyCollection,
  CollectionViewer,
  HeaderCollectionDropdown,
  collectionAudienceLabelMap,
  CollectionOwners,
  EditCollectionOwners,
};
